export const lang = document.querySelector('html').lang;

const translations = window.__msiaTranslations || {};

export function __(text) {
    return Object.prototype.hasOwnProperty.call(translations, text) ? translations[text] : text;
}
